// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__\\+JOu7 {
  /* padding: 0 2rem; */
}

.styles_paper__iiZwv {
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  height: auto;
  min-height: 0;
  /* max-height: 85vh; */
  /* padding: 1rem; */
  position: relative;
  width: 100%;
  /* Previne animações/transições que causam "pulo" na tela */
  will-change: auto;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.styles_containerTable__0ogiI {
  box-sizing: border-box;
  margin-top: 1rem;
  /* Cresce com a tabela/lista; rolagem vertical fica na página, não presa no card */
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
}

.styles_containerTableLoading__parNz {
  position: relative;
}

.styles_tableOverlay__gDK-S {
  align-items: center;
  background: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}

.styles_noData__BA0Zv {
  align-items: center;
  color: #18316e;
  display: flex;
  gap: 1rem;
  margin: 0 0 2rem 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableCardv2/styles.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,2DAA2D;EAC3D,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kFAAkF;EAClF,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB","sourcesContent":[".container {\n  /* padding: 0 2rem; */\n}\n\n.paper {\n  background: #fff;\n  border-radius: 5px;\n  box-sizing: border-box;\n  height: auto;\n  min-height: 0;\n  /* max-height: 85vh; */\n  /* padding: 1rem; */\n  position: relative;\n  width: 100%;\n  /* Previne animações/transições que causam \"pulo\" na tela */\n  will-change: auto;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n.containerTable {\n  box-sizing: border-box;\n  margin-top: 1rem;\n  /* Cresce com a tabela/lista; rolagem vertical fica na página, não presa no card */\n  overflow-x: auto;\n  overflow-y: visible;\n  width: 100%;\n}\n\n.containerTableLoading {\n  position: relative;\n}\n\n.tableOverlay {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 5;\n}\n\n.noData {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  gap: 1rem;\n  margin: 0 0 2rem 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__+JOu7`,
	"paper": `styles_paper__iiZwv`,
	"containerTable": `styles_containerTable__0ogiI`,
	"containerTableLoading": `styles_containerTableLoading__parNz`,
	"tableOverlay": `styles_tableOverlay__gDK-S`,
	"noData": `styles_noData__BA0Zv`
};
export default ___CSS_LOADER_EXPORT___;
